import { getDataOrNil } from '../../../helpers/getDataOrNil'

export const getFixedSum = (arg1?: number, arg2?: number) => {
  const sum = getDataOrNil(arg1) + getDataOrNil(arg2)
  return Number(sum.toFixed(2))
}
